import { Component, OnInit } from '@angular/core';
import { Route, Router } from '@angular/router';
import { OrderPipe } from 'ngx-order-pipe';
import { ApiService } from 'src/app/shared/services/api.service';
import { UtilService } from 'src/app/shared/services/util.service';
@Component({
  selector: 'app-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.scss'],
  providers: [OrderPipe]
})
export class SidenavComponent implements OnInit {
  allroles: any = []
  selectedRole = localStorage.getItem('role_id');
  selectedDetails: any = [];
  screenData: any = []
  serviceData: any = [];
  roleData: any = [];
  rolescreenMap = {};
  groupedMenu = []

  constructor(private api: ApiService, private util: UtilService, private route: Router) { }
  ngOnInit() {
    this.getAllScreens();
  }
  getAllScreens() {
    this.api.getAllServices().subscribe(response => {
      this.serviceData = response;
      localStorage.setItem('screen', JSON.stringify(this.serviceData))
      this.getAllRoles();
    })
  }
  getAllRoles() {
    this.api.getAllroles().subscribe(response => {
      if (Array.isArray(response)) {
        this.roleData = response;
        this.roleScreenMapping();
      } else {
        this.route.navigate(['/DVT-home'])
      }
    });
  }



  roleScreenMapping() {
    this.roleData.forEach(role => {
      if (role.roleId == this.selectedRole) {
        this.selectedDetails = role
        this.selectedDetails.screens.forEach(screen => {
          this.serviceData.forEach(element => {
            if (screen.screenId == element.screenId) {
              screen['screenName'] = element.screenName
              screen['screenDescription'] = element.screenDescription
              screen['icon'] = element.icon
              screen['path'] = element.path
              screen['parentId'] = element.parentId
              screen['parentName'] = element.parentName
            }
          });
        });
      }
    });
    this.selectedDetails.screens.sort(function (a, b) {
      return a.screenId - b.screenId;
    })
    let group = new Set(this.selectedDetails.screens.map(item => item.parentName));
    this.groupedMenu = [];
    group.forEach(m => {
      this.groupedMenu.push({
        name: m,
        values: this.selectedDetails.screens.filter(i => i.parentName === m)
      })
      console.log("m",m)

    })
    console.log("menu group menu", this.groupedMenu)
    //  this.groupedMenu = this.groupBy(this.selectedDetails.screens, 'parentName');
  }


}
